import styled, { css } from 'styled-components';
import { scrollingHorizontalVisible } from '@/styles/utilities';

export const Element = styled.div`
  ${({ theme, ...props }) => {
    return css`
      border-radius: ${theme.radius.xs} ${theme.radius.xs} 0 0;
      background: ${theme.color.primary_100};
      padding: 0 ${theme.spacing.sm};

      display: flex;
      gap: ${theme.spacing.sm};

      @media screen and (min-width: ${theme.breakpoint.sm}) {
        padding: 0 ${theme.spacing.base};
      }

      @media screen and (max-width: ${theme.breakpoint.sm}) {
        overflow-x: scroll;
        touch-action: pan-x;
        ${scrollingHorizontalVisible};
      }
    `;
  }};
`;
